'use client';

// 通过图片ping的方式检测OA是否登录
import { useEffect, useState } from 'react';

type IProps = {
  pingURL?: string;
  cb?: (isOALogin: boolean) => void;
};

const openTest = false; // 打开测试环境的访问权限
export const usePingOA = ({
  pingURL = `https://codesign.woa.com/status.gif?${new Date().getTime()}`,
  cb,
}: IProps) => {
  const [isOALogin, setIsOALogin] = useState(false); // loading success failed

  const isProd = process.env.NEXT_PUBLIC_APP_ENV === 'production';

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setIsOALogin(true);
      cb && cb(true);
    };
    img.onerror = () => {
      setIsOALogin(false);
      if (openTest) return cb && cb(!isProd);
      cb && cb(false);
    };
    img.src = pingURL;
  }, []);
  if (openTest) return isProd ? isOALogin : true;

  return isOALogin;
};
